module.exports = __webpack_public_path__ + "img/banner-9.ae669d39.jpg";